import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  button: { marginBottom: '10px' },
  container: {
    marginLeft: '20px',
  },
  dataGrid: {
    '&.MuiDataGrid-root .MuiDataGrid-cell, &.MuiDataGrid-root .MuiDataGrid-columnHeader': {
      '&:focus, &:focus-within': {
        outline: 'none',
      },
    },
  },
}));
